function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

import React from "react";
import PropTypes from "prop-types";
import { formatTime } from "../../Misc/Utils";
import DefaultBlueButton from "../../Misc/Buttons/DefaultBlueButton";
import ScriptGenerationAssistant from "./ScriptGenerationAssistant";

var ScriptEditor = function (_React$Component) {
  _inherits(ScriptEditor, _React$Component);

  function ScriptEditor() {
    var _temp, _this, _ret;

    _classCallCheck(this, ScriptEditor);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
      script: ""
    }, _this.initializeTextarea = function (textarea) {
      if (!textarea) {
        return;
      }

      textarea.oninput = textarea.onpropertychange = function () {
        this.style.height = "0px";
        this.style.height = this.scrollHeight + "px";
      };

      _this.resetScriptText = function () {
        _this.setState({
          script: _this.props.script
        });

        setTimeout(function () {
          return textarea.oninput();
        });
      };

      _this.textarea = textarea;
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  ScriptEditor.prototype.componentDidMount = function componentDidMount() {
    this.resetScriptText();
  };

  ScriptEditor.prototype.componentWillUnmount = function componentWillUnmount() {
    this.textarea.oninput = this.textarea.onpropertychange = null;
  };

  ScriptEditor.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
    if (prevProps.script !== this.props.script) {
      this.resetScriptText();
    }
  };

  ScriptEditor.prototype.render = function render() {
    var _this2 = this;

    var _props = this.props,
        isActive = _props.isActive,
        onSubmit = _props.onSubmit,
        onCancel = _props.onCancel,
        assistScriptGeneration = _props.assistScriptGeneration;
    var _state = this.state,
        script = _state.script,
        _state$showGeneratorS = _state.showGeneratorSettings,
        showGeneratorSettings = _state$showGeneratorS === undefined ? false : _state$showGeneratorS;
    var scriptWordsCount = script.split(" ").length;
    return React.createElement("div", {
      className: "modal modal--style-pull-right modal--type-script-edit " + (isActive ? "is-active" : null)
    }, React.createElement("div", {
      className: "modal__outside-close"
    }), React.createElement("div", {
      className: "modal__window"
    }, React.createElement("div", {
      className: "modal__window-content"
    }, React.createElement("div", {
      className: "modal__header"
    }, React.createElement("button", {
      className: "modal__header-cancel button button--reset button--link",
      onClick: onCancel
    }, "Cancel"), React.createElement("button", {
      className: "modal__header-reset button button--reset button--link",
      onClick: this.resetScriptText
    }, "Reset"), React.createElement(DefaultBlueButton, {
      size: "s",
      className: "modal__header-save",
      onClick: function onClick() {
        return onSubmit(script);
      }
    }, "Save")), React.createElement("div", {
      className: "modal__title"
    }, "recording script"), React.createElement("div", {
      className: "modal__intro"
    }, "Edit the text below to make the script your own"), React.createElement("div", {
      className: "modal__duration"
    }, "Estimated length: ", formatTime(scriptWordsCount / 3)), React.createElement("textarea", {
      placeholder: "< enter script here >",
      className: "modal__text chatgpt-textarea",
      ref: this.initializeTextarea,
      value: script,
      onChange: function onChange(event) {
        return _this2.setState({
          script: event.target.value
        });
      }
    }), assistScriptGeneration && React.createElement(DefaultBlueButton, {
      size: "m",
      className: "modal__header-save",
      style: {
        marginTop: 20,
        marginLeft: 0,
        width: "100%"
      },
      onClick: function onClick() {
        return _this2.setState({
          showGeneratorSettings: true
        });
      }
    }, "Ask ChatGPT for Script"), assistScriptGeneration && React.createElement(ScriptGenerationAssistant, {
      onReady: function onReady(script) {
        _this2.setState({
          script: script
        });

        setTimeout(function () {
          return _this2.textarea.oninput();
        });
      },
      onClose: function onClose() {
        return _this2.setState({
          showGeneratorSettings: false
        });
      },
      isActive: showGeneratorSettings,
      assistScriptGeneration: assistScriptGeneration
    }))));
  };

  return ScriptEditor;
}(React.Component);

ScriptEditor.propTypes = process.env.NODE_ENV !== "production" ? {
  isActive: PropTypes.bool,
  script: PropTypes.string.isRequired,
  onCancel: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  assistScriptGeneration: PropTypes.func
} : {};
export default ScriptEditor;